import api from '../../../utils/api';

export const buddiesService = {
  async listBuddies() {
    const resp = await api.get('/buddies/');
    return resp.data.results || [];
  },

  /** Viewer + accepted buddies currently tagged into a stand. */
  async getInTheStandCount() {
    const resp = await api.get('/buddies/in-the-stand/');
    return Number(resp?.data?.count) || 0;
  },

  async listRequests() {
    const resp = await api.get('/buddies/requests/');
    return resp.data;
  },

  async sendRequest(toUserId) {
    const resp = await api.post('/buddies/requests/', { to_user_id: toUserId });
    return resp.data;
  },

  async acceptRequest(requestId) {
    const resp = await api.post(`/buddies/requests/${requestId}/accept`);
    return resp.data;
  },

  async declineRequest(requestId) {
    const resp = await api.post(`/buddies/requests/${requestId}/decline`);
    return resp.data;
  },

  async userPhotos(userId) {
    const resp = await api.get(`/users/${userId}/photos/`);
    return resp.data;
  },

  async getUserPhotos(userId) {
    return this.userPhotos(userId);
  },

  async searchUsers(query) {
    const resp = await api.get(`/users/search/`, { params: { q: query } });
    return resp.data?.results || [];
  },
};

export default buddiesService;

